// import Vue from 'vue'
// import { Model } from '@vuex-orm/core'

import Product from './product.model'

// import Composition from './composition.model'

export default class Order extends Product {
  static entity = 'orders'

  get total() {
    const sumAditions = this.aditions.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    )
    return this.basePrice + sumAditions
  }

  get isCompleted() {
    return this.compositions.length === this.baseCountItems
  }
}
